import { useLocation, useNavigate } from 'react-router-dom';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

function trackForSale(source: string) {
  if (window.gtag) {
    window.gtag('event', 'for_sale_click', { source });
  }
}

export default function ForSaleBadge() {
  const location = useLocation();
  const navigate = useNavigate();

  // Hide on admin pages
  if (location.pathname.startsWith('/admin')) return null;

  const handleClick = () => {
    trackForSale('sticky_badge');
    navigate('/for-sale');
  };

  return (
    <button
      onClick={handleClick}
      aria-label="This website is for sale"
      className="fixed top-20 right-4 md:top-24 md:right-6 z-50 cursor-pointer group"
      style={{ filter: 'drop-shadow(0 4px 12px rgba(220,38,38,0.45))' }}
    >
      <div className="relative bg-[#DC2626] text-white rounded-lg px-4 py-2.5 animate-pulse-slow hover:animate-none hover:scale-105 transition-transform">
        {/* Corner notch effect */}
        <div className="absolute -top-1 -left-1 w-2 h-2 bg-[#991b1b] rounded-br"></div>
        <div className="absolute -bottom-1 -right-1 w-2 h-2 bg-[#991b1b] rounded-tl"></div>

        <div className="flex items-center gap-2">
          <div className="w-2 h-2 bg-white rounded-full animate-ping opacity-75 flex-shrink-0"></div>
          <div>
            <div className="text-xs font-black tracking-widest uppercase leading-none">For Sale</div>
            <div className="text-xs text-red-200 leading-none mt-0.5 whitespace-nowrap">Own This Website</div>
          </div>
          <i className="ri-arrow-right-line text-red-200 text-xs ml-1"></i>
        </div>
      </div>
    </button>
  );
}
